// GA4 page views on Turbo navigations (initial load + every turbo:visit).
// Requires layouts/_google_analytics.html.erb with send_page_view: false.
document.addEventListener("turbo:load", () => {
  if (typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search
  });
});
